import React from 'react'
import { useTranslation } from 'react-i18next'



const OrderSummary = ({cart, discount, taxe, shippingCost, totalItems,orderTotal}) => {

    const {t} = useTranslation();
 
  return (
    <div className='mt-4'>
    <h2 className="text-xl font-semibold mb-4">{t('order.orderSummary')}</h2>
    <div className="bg-gray-50 p-4 rounded-lg">
         <div className="flex justify-between font-semibold border-b pb-2 mb-2">
          <span className="w-1/3">{t('order.item')}</span>
          <span className="w-1/3 text-center">{t('order.quantity')}</span>
          <span className="w-1/3 text-right">{t('order.subtotal')}</span>
        </div>

        <ul className="space-y-2">
          {cart.map(item => (
            <li className="flex justify-between" key={item.id}>
              <span className="w-1/3">{item.name}</span>
              <span className="w-1/3 text-center">{item.quantity}</span>
              <span className="w-1/3 text-right">{(item.quantity * item.price).toFixed(2)} MAD</span>
            </li>
          ))}
        </ul>
      <ul className="space-y-2">
        <li className="flex justify-between">
          <span>Items Total</span>
          <span>{totalItems?.toFixed(2)} MAD</span>
        </li>
        <li className="flex justify-between">
          <span>Taxes total:</span>
          <span>{taxe} MAD</span>
        </li>
        <li className="flex justify-between">
          <span>Discount:</span>
          <span>{discount} MAD</span>
        </li>
        <li className="flex justify-between">
          <span>Estimated shipping cost:</span>
          <span>{shippingCost} MAD</span>
        </li>
      </ul>
      <hr className="my-2" />
      <div className="flex justify-between font-bold">
        <span>Order total:</span>
        <span>{orderTotal?.toFixed(2)} MAD</span>
      </div>
    </div>
  </div>
  )
}

export default OrderSummary